import React   from 'react';

class ViewExporter extends React.Component {

	constructor(props) {
		super(props);
        this.state = {
			data:    "",
			loading: false,
		};

	}

	componentDidMount() {
		this.loadData();
	}


	loadData(reload = false) {
		const view   = this.props.view;
		//const filter = this.props.filter;
		//const data   = this.state.data;
		//this.setState({loading: true});
        
		this.props.model.getExport(view.id)
			.then(response => {
                console.log(response);
				this.setState({
					data:    response.data,
					loading: false
				});
			});
	}

	render() {
		return(
			<div className="html-container" dangerouslySetInnerHTML={{__html: this.state.data}} />
		);
	}

}

export default ViewExporter;
